export default "/assets/4be21246d766c69a.png"